import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// component

// selector
import { routerPrivate } from "./route/router_private";
import { routePublict } from "./route/router_publict";
import { LoadingScreen } from "component/loading";
import { useLogged } from "hook/useLogged";
// redux

const Router = () => {
  // -------------------------- STATE ---------------------------
  const { logged } = useLogged();
  // -------------------------- REDUX ---------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- MAIN ----------------------------
  // -------------------------- RENDER --------------------------
  // logged = nul -> loading. sau khi loading.

  if (logged === null) {
    return <LoadingScreen />;
  }

  return (
    <BrowserRouter>
      <Routes>
        {logged ? routerPrivate() : routePublict()}
        <Route path="*" element={<Navigate to={"/"} exact replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
